import type { TableView } from 'owa-mail-list-store';
import { mutatorAction } from 'satcheljs';

const setFocusedRowKeyMutator: (tableView: TableView, focusedRowKey: string) => void =
    mutatorAction(
        'setFocusedRowKey',
        function setFocusedRowKey(tableView: TableView, focusedRowKey: string): void {
            tableView.focusedRowKey = focusedRowKey;
        }
    );
export default setFocusedRowKeyMutator;
